import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';

import Routes from '../../pages/Routes';

import NavBar from './_components/NavBar';
import TopBar from './_components/TopBar';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    height: '100%',
    flexGrow: 1,
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256,
    },
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    height: '100%',
    flexGrow: 1,
  },
  content: {
    flex: '1 1 auto',
    overflow: 'auto',
    height: '100%',
    flexGrow: 1,
  },
}));

const DashboardLayout = () => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className={classes.root}>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <Routes />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
